/* eslint-disable react/no-danger */
import { IconActionChevronUp16 } from '@cian/ui-kit-design-tokens/icons';

import classNames from 'classnames';
import * as React from 'react';

import * as styles from './SeoMarkedListItem.css';

const SPACE_KEY_CODE = 32;

export interface ISeoMarkedListItemProps {
  id: string;
  title: string;
  content: string;
}

export const SeoMarkedListItem: React.FC<ISeoMarkedListItemProps> = ({ id, title, content }) => {
  const [expanded, setExpanded] = React.useState<boolean>(false);
  const headingId = `${id}_heading`;
  const bodyId = `${id}_body`;

  /**
   * React 19 сравнивает пропсы DOM-узла по ссылке и на каждый ререндер заново присваивает innerHTML,
   * поэтому объекты для dangerouslySetInnerHTML держим стабильными.
   */
  const titleMarkup = React.useMemo(() => ({ __html: title }), [title]);
  const contentMarkup = React.useMemo(() => ({ __html: content }), [content]);

  const toggleExpandedState = () => {
    setExpanded(!expanded);
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.keyCode === SPACE_KEY_CODE) {
      event.preventDefault();

      toggleExpandedState();
    }
  };

  return (
    <div className={classNames(styles['container'], !expanded && styles['closed'])}>
      {/**
        Почему здесь не стоит использовать button описано тут
        https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/button_role
      */}
      <div
        aria-controls={bodyId}
        aria-expanded={expanded}
        className={styles['title-block']}
        id={headingId}
        role="button"
        tabIndex={0}
        onClick={toggleExpandedState}
        onKeyDown={handleKeyDown}
      >
        <div className={styles['title']} dangerouslySetInnerHTML={titleMarkup} />
        <div className={styles['arrow-wrapper']}>
          <IconActionChevronUp16 />
        </div>
      </div>
      <div
        aria-describedby={headingId}
        className={styles['content']}
        dangerouslySetInnerHTML={contentMarkup}
        id={bodyId}
      />
    </div>
  );
};
